import {connect} from 'react-redux';
import {TooltipControls as Component} from './TooltipControls';


function mapStateToProps(state, ownProps) {
  if(state.notebook.protocolSection.scene.apparatus.hasOwnProperty("waterBath") &&
  state.notebook.protocolSection.scene.apparatus.gelBoxes.some(
    trash => trash.id === ownProps.id
  )
){
 return {
  id: ownProps.id,
  type: state.notebook.protocolSection.scene.apparatus.floatingTubeRack[ownProps.id - 1].type,
  count: state.notebook.protocolSection.scene.apparatus.floatingTubeRack[ownProps.id-1].count,
 }
} else {
 return {}
}
}

function mapDispatchToProps(dispatch) {

  return {
  };


}
export const TooltipControls = connect(
  mapStateToProps,
  mapDispatchToProps
)(Component);
